import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function countries(state=initialState.countries, action) {
     switch (action.type) {
        case commonConstants.COUNTRIES_SUCCESS:
            return Object.assign({}, state, action.countries);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/countries.reducer.js